// IMPORTANT: this file must stay in sync with functions/src/types.ts.

export interface LineItem {
  description: string;
  amount: number;
}

export interface MwstBreakdownEntry {
  rate: number;
  amount: number;
}

export const EXPENSE_CATEGORIES = [
  "Büro Bestandsmaterial (EDV, Einrichtung)",
  "Büro Verbrauchsmaterial",
  "Repräsentationsspesen (Kundengeschenke, Kundenessen)",
  "Mitarbeitergeschenke",
  "Reisespesen",
  "Verpflegung auswärts",
  "Konferenz",
  "Andere",
] as const;
export type ExpenseCategory = typeof EXPENSE_CATEGORIES[number];

export const BELEG_TYPS = ["Spesen", "Rückvergütung", "Kreditkartenbelege"] as const;
export type BelegTyp = typeof BELEG_TYPS[number];

export interface ScanResponse {
  merchant: string;
  merchantUid: string | null;
  receiptDate: string | null;
  currency: string;
  items: LineItem[];
  mwstBreakdown: MwstBreakdownEntry[];
  total: number;
  confidence: "high" | "medium" | "low";
  parseFailed?: boolean;
}

export interface SubmitRequest {
  receiptId: string;
  employee: string;
  merchant: string;
  merchantUid: string | null;
  receiptDate: string;
  currency: string;
  items: LineItem[];
  bezeichnung: string;
  category: ExpenseCategory;
  belegTyp: BelegTyp;
  images: { mimeType: string; dataBase64: string }[];
}

export interface SubmitResponse {
  receiptId: string;
  total: number;
  rowsAppended: number;
  receiptLink: string;
  sheetUrl: string;
}
